export default __webpack_public_path__ + "99cc65fd9cf58231aa6ef334053ee4fe.png";